import type { FormData } from 'src/types/appState';

export default (formData?: FormData, field: string = '') => {
  const thisField = formData?.[field];
  if (typeof thisField === 'string' || typeof thisField === 'number') {
    return Boolean(thisField);
  }
  if (Array.isArray(thisField)) {
    return thisField.length > 0;
  }
  return typeof thisField === 'boolean';
};
